import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";

@Component({
    selector: "app-auto-click-button",
    templateUrl: "./auto-click-button.component.html",
    styleUrls: ["./auto-click-button.component.scss"],
    standalone: true,
})
export class AutoClickButtonComponent implements OnInit, OnDestroy {
  @Input() buttonText = "";
  @Input() delay = 3000;
  /**
   * Increment from the parent to re-enable the CTA after a failed continue attempt.
   * Initial 0 does nothing; any later increase calls reset().
   */
  @Input()
  set resetKey(value: number) {
    if (value == null || value === this._resetKey) {
      return;
    }
    this._resetKey = value;
    if (value > 0) {
      this.reset();
    }
  }
  @Output() buttonClick = new EventEmitter();
  @ViewChild("button") buttonElement!: ElementRef;
  progress = 0;
  isDisabled = false;
  private intervalId: ReturnType<typeof setInterval> | undefined;
  private _resetKey = 0;

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    this.clearCountdown();
  }

  startCountdown() {
    this.clearCountdown();
    const startTime = Date.now();
    this.intervalId = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      this.progress = (elapsedTime / this.delay) * 100;

      if (elapsedTime >= this.delay) {
        this.autoClick();
        this.clearCountdown();
      }
    }, 100);
  }

  autoClick() {
    this.isDisabled = true;
    this.progress = 100;
    this.buttonElement?.nativeElement?.click();
  }

  onClick() {
    this.clearCountdown();
    this.isDisabled = true;
    this.progress = 100;
    this.buttonClick.emit();
  }

  /** Re-enable the button after a failed navigation/continue attempt (no auto re-fire). */
  reset() {
    this.clearCountdown();
    this.isDisabled = false;
    this.progress = 0;
  }

  private clearCountdown() {
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }
}
